import React, { useRef, useState } from "react";
import "./Hobbies.css";
import Carousel from "../components/Carousel";
import { useTranslation } from "react-i18next";
import useSectionHeader from "../hooks/useSectionHeader";
import useAutoPlayVideo from "../hooks/useAutoPlayVideo";

function VideoCaption({ date }) {
  return (
    <div className="video-caption">
      <i className="fa-solid fa-film"></i>
      <span>{date}</span>
    </div>
  );
}

function Hobbies() {
  const { t } = useTranslation("hobbies");

  const phogRef = useRef(null);
  const soccerRef = useRef(null);
  const video1Ref = useRef(null);
  const video2Ref = useRef(null);
  const [playVid2, setPlayVid2] = useState(false);

  // reusable observer hook
  useSectionHeader(phogRef, "hobbies:sections.photography");
  useSectionHeader(soccerRef, "hobbies:sections.soccer");

  // play videos in view, pause out of view
  useAutoPlayVideo(video1Ref);
  useAutoPlayVideo(video2Ref);

  return (
    <>
      <section id="photography" ref={phogRef}>
        <Carousel />
      </section>

      <section id="soccer" ref={soccerRef}>
        <div className="grid-wrapper">
          <div className="grid-item">
            <VideoCaption date={t("soccer.video1Caption")} />

            <video ref={video1Ref} src="/videos/soccer1.mp4" playsInline muted loop />
          </div>

          <div className="grid-item">
            <div id="video-comment" className={playVid2 ? "show" : ""}>
              <p>{t("soccer.description")}</p>
            </div>

            <VideoCaption date={t("soccer.video2Caption")} />

            <video
              ref={video2Ref}
              src="/videos/soccer2.mp4"
              playsInline
              muted
              loop
              onPlay={() => {
                  if (!playVid2) {
                      setPlayVid2(true);
                  }
              }}
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Hobbies;